module.exports = __webpack_public_path__ + "static/img/tongyong_zy_01.ccf148e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tongyong_zy_01.png
// module id = hgnb
// module chunks = 0